var _clipPath, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBanner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 55,
    viewBox: "0 0 55 55",
    width: 55,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.25.25h54.75v54.75h-54.75z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17.9727 36.2787-14.93453-21.1953c-3.0281221-4.2976-8.96676-5.32669-13.26437-2.2986l20.13395 28.5744c1.91065 2.7117 4.98015 4.1221 8.06495 4.033 3.0848.0891 6.1542-1.3213 8.0649-4.033l20.1339-28.5744c-4.2976-3.02809-10.2362-1.999-13.2643 2.2986z",
    fill: "#effbfe",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.5078 36.2842-14.9384-21.2008c-3.0281-4.2976-8.9667-5.32669-13.2643-2.2986l20.1339 28.5744c1.9115 2.7128 4.9827 4.1233 8.0688 4.0329 3.0862.0904 6.1574-1.3201 8.0689-4.0329l20.1339-28.5744c-4.2976-3.02809-10.2362-1.999-13.2644 2.2986z",
    fill: "#c6dcf5",
    opacity: 0.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanner);
export default __webpack_public_path__ + "static/media/banner.9094714e2ba31c0d648ce5f5be121ff2.svg";
export { ForwardRef as ReactComponent };